import isObject from "lodash/isObject";
import moment from "../../../moment";
import config from "../../../config";
import { getHTMLWords } from "../../../components/TinyMCE/methods";
import { getInitialValidity, VALIDITY_BOOL_MAP } from "./trainingValidityHelpers";

export { TABLE_TRG_TRAININGS } from "./trainingConstants";
export { generateColumns } from "./trainingColumns";
export { downloadTrgSingleTraining } from "./trainingExport";
export { getInitialValidity } from "./trainingValidityHelpers";

/**
 * Transforms raw training form values into the API payload.
 * Resolves all_branches, formats specific_date, applies validity bool flags.
 *
 * @param {object} values - Raw form values from the training form.
 * @returns {object} API-ready payload object.
 */
export const prepareTrainingDataToSend = (values) => {
  const { range_of_validity, internal_provider, validity, specific_date } = values;
  const firstBranch = range_of_validity ? range_of_validity[0] : null;
  const all_branches = isObject(firstBranch) ? firstBranch.all_branches : false;

  return {
    ...values,
    all_branches,
    internal_provider: !!internal_provider,
    no_expiry: validity === "no_expiry",
    description_length: getHTMLWords(values.description).charactersLength,
    ...VALIDITY_BOOL_MAP[validity],
    ...(specific_date ? { specific_date: moment(specific_date).format(config.defaultDateFormat) } : {}),
    ...(all_branches ? {} : { branches: range_of_validity })
  };
};

/**
 * Returns true when the validity configuration in the form differs from the saved training.
 * Used by `beforeSubmit` to decide whether a confirmation dialog is needed.
 *
 * @param {object} data - Training record as loaded from the server.
 * @param {import("rc-field-form").FormInstance} form - The Ant Design form instance.
 * @returns {boolean}
 */
export const hasValidityChanged = (data, form) => {
  const specificDateValidity = form.getFieldValue("specific_date")
    ? moment(form.getFieldValue("specific_date")).format(config.defaultDateLongFormat)
    : null;

  return (
    getInitialValidity(data) !== form.getFieldValue("validity") ||
    form.getFieldValue("day_number") !== data.validity?.day_number ||
    form.getFieldValue("year_number") !== data.validity?.year_number ||
    specificDateValidity !== data.validity?.specific_date ||
    form.getFieldValue("years_minus_one_day") !== data.validity?.years_minus_one_day
  );
};
